import { useMemo } from 'react';
import { css } from '@emotion/react';
import { OperatoryDetails } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/operatory.pb';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { styles } from '@frontend/design-system';
import { getOperatoryAvatarInfoByName } from '../helpers';

type OperatoryAvatarProps = {
  avatarInfo?: OperatoryDetails['icon'];
  operatoryName?: string;
  iconSize?: number;
  disabled?: boolean;
};

export const OperatoryAvatar = ({
  avatarInfo,
  operatoryName,
  iconSize = 24,
  disabled = false,
}: OperatoryAvatarProps) => {
  const { color: operatoryColor, icon: operatoryIcon } = useMemo(
    () => getOperatoryAvatarInfoByName(operatoryName, avatarInfo),
    [avatarInfo, operatoryName]
  );

  return (
    <div css={[styles.flexCenter, wrapperStyle(operatoryColor, disabled)]}>
      <Icon size={iconSize} color='default' name={operatoryIcon} />
    </div>
  );
};

const wrapperStyle = (color: string, disabled: boolean) =>
  css({
    maxWidth: 'max-content',
    borderRadius: theme.borderRadius.medium,
    backgroundColor: color,
    padding: theme.spacing(0.5),
    opacity: disabled ? 0.5 : 1,
  });
